import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

const success = response => response.data;

const error = () => {};

export default (id, filter) => Vue.$http
    .get(`users/${encodePathSegment(id)}`, { params: filter })
    .then(success)
    .catch(error);



// WEBPACK FOOTER //
// ./src/services/user/getOne.js